const data = {
	"width": 256,
	"height": 256,
	"body": "<path fill=\"currentColor\" d=\"m213.7 101.7l-80 80a8.2 8.2 0 0 1-11.4 0l-80-80a8.4 8.4 0 0 1-1.7-8.8A8 8 0 0 1 48 88h160a8 8 0 0 1 7.4 4.9a8.4 8.4 0 0 1-1.7 8.8Z\"/>"
};
export default data;
